import * as consts from '@/constants';

export default {
  sendMessageStatusLoad: consts.REQUEST_WITHOUT_STARTING,
  errorsSendMessage: null,
};
